import { lazy, Suspense } from "react";
import { ThinkingDot } from "./Chat";

import { useChallenge } from "../hooks";
import { useAppSelector } from "../store";
const Gate = lazy(() => import("./Gate"));

function LoadingPage() {
  return (
    <div
      role="status"
      className="h-[100dvh] w-full flex items-center justify-center"
    >
      <ThinkingDot />
      <span className="sr-only">Loading...</span>
    </div>
  );
}

export default function AccessGate({
  children,
}: {
  children: React.ReactNode;
}) {
  const { frameId } = useAppSelector((state) => state.config.data);
  const { challenge, status } = useChallenge(frameId);
  if (!["succeeded", "failed"].includes(status)) {
    return <></>;
  }

  return challenge.is_pass ? (
    <>{children}</>
  ) : (
    <Suspense fallback={<LoadingPage />}>
      <Gate frameId={frameId} />
    </Suspense>
  );
}
